// Comparador de servicios lado a lado: arma las filas de una tabla con lo que ya existe en el contenido.
import contenido from "../contenido";
import { infoServicio } from "modAws/CatalogoAws";

export const MAX_COMPARAR = 3;
export const FILAS = [
    { id: "nivel", titulo: "Nivel", valor: (d) => d.nivel },
    { id: "que", titulo: "Qué es", valor: (d) => d.que },
    { id: "cuando", titulo: "Conviene cuando", valor: (d) => d.cuando },
    { id: "evita", titulo: "Mejor evita usarlo si", valor: (d) => d.evita },
    { id: "cobro", titulo: "Cómo se cobra", valor: (d) => d.cobro },
    { id: "objetos", titulo: "Objetos", valor: (d) => Object.keys(d.objetos) },
    { id: "con", titulo: "Se conecta con", valor: (d) => d.con.map(id => (infoServicio(id) ? infoServicio(id).servicio.title : id)) },
];

// ids -> [{ id, titulo, filas: { nivel, que, ... } }] (solo servicios que existen, sin repetidos, hasta MAX_COMPARAR)
export const columnas = (ids) => [...new Set(ids)].filter(id => infoServicio(id) && contenido[id]).slice(0, MAX_COMPARAR).map(id => ({
    id, titulo: infoServicio(id).servicio.title, color: infoServicio(id).color,
    filas: Object.fromEntries(FILAS.map(f => [f.id, f.valor(contenido[id])])),
}));
